let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ikem6"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("hs6o8")]).then(() => parcelRequire('kB13O'));